export default __webpack_public_path__ + "static/media/seashell4.9f13188c.svg";